// Activity-window sizes mirror the message-window machinery (see messageWindow.ts)
// and are runtime-configurable via env vars:
//   T3CODE_INITIAL_ACTIVITY_WINDOW   — activities in a thread-subscription snapshot (default 200)
//   T3CODE_OLDER_ACTIVITY_PAGE_SIZE  — older activities per reverse-scroll page
//
// Read at module load the same way as messageWindow.ts: real `process.env` on the
// server, and inlined by the Vite `define` step on the web (see apps/web/vite.config.ts).
// Keep the `process.env.T3CODE_*` member expressions verbatim so the Vite define matches.
import { parseInitialWindowSize, parseMessageWindowSize } from "./messageWindow.ts";

declare const process: { readonly env: Record<string, string | undefined> };

export const DEFAULT_INITIAL_ACTIVITY_WINDOW = 200;
export const DEFAULT_OLDER_ACTIVITY_PAGE_SIZE = 100;

/** Number of most-recent activities included in a thread subscription snapshot; `0` = whole thread. */
export const INITIAL_ACTIVITY_WINDOW = parseInitialWindowSize(
  process.env.T3CODE_INITIAL_ACTIVITY_WINDOW,
  DEFAULT_INITIAL_ACTIVITY_WINDOW,
);
/** Number of older activities fetched per reverse-scroll page. */
export const OLDER_ACTIVITY_PAGE_SIZE = parseMessageWindowSize(
  process.env.T3CODE_OLDER_ACTIVITY_PAGE_SIZE,
  DEFAULT_OLDER_ACTIVITY_PAGE_SIZE,
);

/** Activity kinds that live only in the live stream: thread snapshots and older-activity pages skip them. */
export const HISTORY_EXCLUDED_ACTIVITY_KINDS: ReadonlyArray<string> = [
  "tool.started",
  "tool.updated",
  "context-window.updated",
];

export function isHistoryExcludedActivityKind(kind: string): boolean {
  return HISTORY_EXCLUDED_ACTIVITY_KINDS.includes(kind);
}

/** History-excluded kinds whose most recent row every thread snapshot carries. */
export const SNAPSHOT_LATEST_ACTIVITY_KINDS: ReadonlyArray<string> = ["context-window.updated"];
